import { Card, Radio } from "antd";
import { useState } from "react";
interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateLinerScale({ data }: Props) {
  const [value, setValue] = useState<number | null>(null);

  return (
    <>
      <Card className="mt-4">
        <div className=" justify-start text-zinc-700 text-base font-medium">
          Linear Scale - {data?.question_title}
        </div>
        <div className="mt-4 flex justify-center">
          <Radio.Group
            onChange={(e) => setValue(e.target.value)}
            value={data?.answer || value}
          >
            <div className="flex items-center justify-center gap-10">
              <span className="text-zinc-700 text-base font-normal">Text</span>

              {Array.from({ length: data?.linear_scale_to || 0 }).map(
                (_, index) => (
                  <div key={index} className="flex flex-col items-center">
                    <span className="text-zinc-700 text-base font-normal">
                      {index + 1}
                    </span>
                    <Radio value={index + 1} />
                  </div>
                )
              )}

              <span className="text-zinc-700 text-base font-normal">Text</span>
            </div>
          </Radio.Group>
        </div>
      </Card>
    </>
  );
}
